import { render } from "./welcome-back.vue?vue&type=template&id=999286ec"
import script from "./welcome-back.vue?vue&type=script&lang=js"
export * from "./welcome-back.vue?vue&type=script&lang=js"

import "./welcome-back.vue?vue&type=style&index=0&id=999286ec&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__